module.exports = __webpack_public_path__ + "static/assets/09c4f08761f898d66872eabf4579503b.svg";